import { IPriceResponse, ShippingType } from "@gloria-public/order/domain/interfaces/cart.interface";
import { IIdentifierFhir, IReferenceFhir } from "@shared/interfaces/shared.interface";

export interface IServiceRequestTemplateResponse {
  identifier: IIdentifierFhir;
  title: string;
  description?: string;
  price: IPriceResponse;
  availableShippingTypes: ShippingType[];
  prescriptionRequired: boolean;
  type: ServiceType;
  tags: string[];
}

export enum ServiceType {
  SAMPLING = "SAMPLING",
  CALCULATOR = "CALCULATOR",
}

export interface IServiceRequestTemplateWithResults {
  template: IServiceRequestTemplateResponse;
  results: IResultSerializable[];
}

export interface IResultSerializable {
  identifier: IIdentifierFhir;
  basedOn: IReferenceFhir;
  status: IResultStatus;
  valueQuantity?: IQuantity;
  valueString?: string;
  valueBoolean?: boolean;
  valueInteger?: number;
  valueRange?: IRange;
  valueRatio?: IRatio;
  valueAttachment: IAttachmentSerializable;
}

export interface IAttachmentSerializable {
  data?: string;
  url?: string;
  creation: string;
}

export interface IRatio {
  numerator: IQuantity;
  denominator: IQuantity;
}

export interface IRange {
  low: IQuantity;
  high: IQuantity;
}

export interface IQuantity {
  value: number;
  unit: string;
}

export enum IResultStatus {
  READ = "READ",
  NOT_READ = "NOT_READ",
}
